/* eslint-disable no-nested-ternary */
import {
  CircularProgress,
  Drawer,
  Icon,
  Popover,
  Tooltip,
} from '@material-ui/core';
import React, { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { useAlert } from 'react-alert';
import Images from 'assets/img';
import Modal from './components/Modal';
import ConvocationsActions from 'store/ducks/convocations';

import TruckerActions from 'store/ducks/trucker';
import { Column, Row } from 'styles/components';
import QRCode from './components/QRCode';
import CustomScrollbar from 'react-custom-scrollbars';
import { Close } from '@material-ui/icons';


import {
  AddIcon,
  Container,
  DeleteIcon,
  EditIcon,
  EyeIcon,
  PopoverButton,
  PopoverText,
  WrapperAdd,
  WrapperPopover,
  WrapperTable,
  IconPaper,
  Actions,
  Action,
  BoxMap,
  BoxDrawerRight,
  ButtonDrawer,
  Card,
  CloseButton,
} from './styles';
import StaticDrawer from 'components/StaticDrawer';
import Button from 'components/ButtonDrawer';
import ChargeItem from './components/ChargeItem';
import AnimatedSearchInput from 'components/AnimatedSearchInput';
import ModalFilter from './components/ModalFilter';
import { Center, Loading } from '../ConvocationDetails/styles';
import { MapWithAMarker } from 'components/MapConvocationDetails/LeafletMap';
import useSnapshot from 'hooks/useGetUserLocation';
import api from 'services/api';
import { viagensAPI, mdfeAPI, cargasAPI, sefazParamsAPI, truckersAPI, insurancesAPI, rastreamentoAPI } from 'services/apiRest';
import { actions as toastrActions } from 'react-redux-toastr';
import TruckerPopover from './components/TruckerPopover';
import MarkerPopover from './components/MarkerPopover';
import MoreVert from '@material-ui/icons/MoreVert';
import ChevronLeft from '@material-ui/icons/ChevronLeft';
import DrawerItem from 'components/DrawerItem';
import {
  Header,
  Subtitle,
  Title,
  WrapperLeft,
} from 'components/StaticDrawer/styles';
import UserDrawer from 'components/UserDrawer';
import CircleButton from 'components/CircleButton';
import ChargeInfos from './components/ChargeInfos';
import PercurseLogs from './components/PercurseLogs';
import DeleteModal from './components/DeleteModal';
import MessageTruckerModal from './components/MessageTruckerModal';
import { after } from 'lodash';
import { LoadingPage } from 'components/Loading';
import ErrorModal from './components/ErrorModal';
import { MapConvocation } from './components/MapConvocation';
import ModalShare from './components/ModalShare';
import ModalEventosMdfe from './components/ModalEventosMdfe';
import ModalJustificativaCancelamentoMdfe from './components/ModalJustificativaCancelamentoMdfe';
import ModalEncerramentoMdfe from './components/ModalEncerramentoMdfe';
import { FiShare } from 'react-icons/fi';

function Convocations() {
  const dispatch = useDispatch();
  const history = useHistory();
  const alert = useAlert();
  const {
    convocations,
    centerMap,
    convocationActive,
    openModalEdit,
    openModalQrCode,
    deleteModal,
  } = useSelector((state) => state.convocations);

  const [popoverPosition, setPopoverPosition] = useState(null);
  const [markerPopoverPosition, setMarkerPopoverPosition] = useState(null);
  const [open, setOpen] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [openErrorModal, setOpenErrorModal] = useState(false);
  const [openModalEventosMdfe, setOpenModalEventosMdfe] = useState(false);
  const [selectedCargaIdMdfe, setSelectedCargaIdMdfe] = useState(null);
  const [openModalJustificativaCancelamentoMdfe, setOpenModalJustificativaCancelamentoMdfe] = useState(false);
  const [cargaParaCancelar, setCargaParaCancelar] = useState(null);
  const [openModalEncerramentoMdfe, setOpenModalEncerramentoMdfe] = useState(false);
  const [cargaParaEncerrar, setCargaParaEncerrar] = useState(null);
  const [selectedConvocation, setSelectedConvocation] = useState(null);
  const [search, setSearch] = useState('');
  const [filterOpen, setFilterOpen] = useState(false);
  const [shareOpen, setShareOpen] = useState(false);
  const [anchorMenu, setAnchorMenu] = useState(null);
  const [disabledDownload, setDisabledDownload] = useState(true);
  const [filtered, setFiltered] = useState(false);
  const [posCollect, setPosCollect] = useState({
    latitude: 0,
    longitude: 0,
  });
  const [positionDest, setPositionDest] = useState({
    latitude: 0,
    longitude: 0,
  });
  const mapRef = useRef(null);
  const [provider, setProvider] = React.useState({});
  const [paths, setPaths] = useState(null);

  const [filterOptions, setFilterOptions] = useState({
    status: [],
    drivers: [],
    types: [],
    deliveryCities: [],
    deliveryStates: [],
  });

  const { providers } = useSelector((state) => state.providers);
  const truckerLocation = useSnapshot(selectedConvocation);
  const [filteredData, setFilteredData] = useState(null);
  const [anchorEl, setAnchorEl] = useState(null);
  const [cte, setCte] = useState(null);
  const [error, setError] = useState(null);
  const [invoices, setInvoices] = useState(null);
  const [selectedInvoice, setSelectedInvoice] = useState(null);
  const [userPopover, setUserPopover] = useState(null);
  const [openDrawer, setOpenDrawer] = useState(false);
  const [percurseLogs, setPercurseLogs] = useState(false);
  const [loading, setLoading] = useState(false);
  const [pageLoading, setPageLoading] = useState(true);
  const [relatedTrips, setRelatedTrips] = useState([]);
  const [allActiveTrips, setAllActiveTrips] = useState([]); // Todas as viagens não encerradas
  const [allTrackingData, setAllTrackingData] = useState([]); // Todas as últimas localizações de todas as cargas
  const [filteredTrackingData, setFilteredTrackingData] = useState([]); // Localizações filtradas por carga selecionada
  let delayFactor = 0;

  const { latitude, longitude } = truckerLocation;

  const { oneTrucker } = useSelector((state) => state.trucker);

  const key = process.env.REACT_APP_MAPS_KEY;
  const hasValidKey = key && key !== 'undefined' && key.trim() !== '';

  const [formFilter, setFormFilter] = useState({
    id: '',
    startDate: new Date('01/01/2000'),
    endDate: new Date(),
    status: [],
    driver_name: [],
    type: [],
    vehicle: '',
    nfe: '',
    delivery_city: [],
    delivery_state: [],
  });

  const data = convocations.map((item) => ({
    ...item,
    actions: item.id,
    id: item.id,
    requester: item.owner,
    type: item.type,
    created_at: item.created_at ? item.created_at.seconds * 1000 : '',
    validity: item.validity ? item.validity.seconds * 1000 : '',
  }));

  const handleResetFilter = () => {
    setFormFilter({
      id: '',
      startDate: new Date().setFullYear(2000),
      endDate: new Date(),
      status: [],
      driver_name: [],
      type: [],
      vehicle: '',
      nfe: '',
      delivery_city: [],
      delivery_state: [],
    });

    setFilteredData(
      data.filter(
        (item) =>
          (item.requester || '').toUpperCase().includes(search.toUpperCase()) ||
          (item.type || '').toUpperCase().includes(search.toUpperCase())
      )
    );
  };

  const handleFilter = () => {
    setFiltered(true);
    var dataFiltered = data.filter(
      (item) =>
        (item.requester || '').toUpperCase().includes(search.toUpperCase()) ||
        (item.type || '').toUpperCase().includes(search.toUpperCase())
    );

    if (formFilter.id != '') {
      dataFiltered = dataFiltered.filter(
        (item) =>
          item.id != null &&
          String(item.id || '').toUpperCase().includes(formFilter.id.toUpperCase())
      );
    }
    if (formFilter.nfe != '') {
      dataFiltered = dataFiltered.filter(
        (item) =>
          item.nfe != null &&
          String(item.nfe || '').toUpperCase().includes(formFilter.nfe.toUpperCase())
      );
    }
    if (formFilter.vehicle != '') {
      dataFiltered = dataFiltered.filter(
        (item) =>
          item.vehicle != null &&
          String(item.vehicle || '').toUpperCase().includes(formFilter.vehicle.toUpperCase())
      );
    }
    if (formFilter.type.length > 0) {
      var filteredData = [];

      formFilter.type.map((typ) => {
        filteredData.push(
          ...dataFiltered.filter(
            (item) =>
              item.type != null &&
              String(item.type || '').toUpperCase().includes(String(typ.value || '').toUpperCase())
          )
        );
      });

      dataFiltered = filteredData;
    }
    if (formFilter.status.length > 0) {
      var filteredData = [];

      formFilter.status.map((stats) => {
        filteredData.push(
          ...dataFiltered.filter(
            (item) =>
              item.status != null &&
              String(item.status || '').toUpperCase() == String(stats.value || '').toUpperCase()
          )
        );
      });

      dataFiltered = filteredData;
    }
    if (formFilter.driver_name != '') {
      var filteredData = [];

      formFilter.driver_name.map((driver) => {
        filteredData.push(
          ...dataFiltered.filter(
            (item) =>
              item.driver_name != null &&
              String(item.driver_name || '').toUpperCase() == String(driver.value || '').toUpperCase()
          )
        );
      });

      dataFiltered = filteredData;
    }
    if (formFilter.delivery_state.length > 0) {
      var filteredData = [];

      formFilter.delivery_state.map((state) => {
        filteredData.push(
          ...dataFiltered.filter(
            (item) =>
              item.delivery_state != null &&
              String(item.delivery_state || '').toUpperCase().includes(String(state || '').toUpperCase())
          )
        );
      });

      dataFiltered = filteredData;
    }
    if (formFilter.delivery_city.length) {
      var filteredData = [];

      formFilter.delivery_city.map((city) => {
        filteredData.push(
          ...dataFiltered.filter(
            (item) =>
              item.delivery_city != null &&
              String(item.delivery_city || '').toUpperCase().includes(String(city || '').toUpperCase())
          )
        );
      });

      dataFiltered = filteredData;
    }
    if (formFilter.created_at != '') {
      var selectedDateOne = new Date(formFilter.startDate);
      var selectedDateTwo = new Date(formFilter.endDate);

      selectedDateOne = selectedDateOne.setHours(0, 0, 0);

      selectedDateTwo = selectedDateTwo.setHours(23, 59, 59);

      dataFiltered = dataFiltered.filter((item) => {
        var itemDate = new Date(item.created_at);

        return (
          item.created_at != null &&
          itemDate >= selectedDateOne &&
          itemDate <= selectedDateTwo
        );
      });
    }
    // console.log('formFilter', formFilter);
    // console.log('dataFiltered', dataFiltered);

    setFilteredData(dataFiltered);
    handleCloseFilter();
  };

  const updateSelectorsOptions = () => {
    var options = {
      status: [],
      drivers: [],
      types: [],
      deliveryCities: [],
      deliveryStates: [],
    };

    data.map((item) => {
      if (item.status && !alreadyExists(item.status, options.status)) {
        options.status.push(item.status);
      }
      if (item.driver_name && !alreadyExists(item.driver_name, options.drivers)) {
        options.drivers.push(item.driver_name);
      }
      if (item.type && !alreadyExists(item.type, options.types)) {
        options.types.push(item.type);
      }
      if (item.delivery_state && item.delivery_state.length >= 2) {
        const stateCode = item.delivery_state.substring(0, 2);
        if (!alreadyExists(stateCode, options.deliveryStates)) {
          options.deliveryStates.push(stateCode);
        }
      }
    });

    setFilterOptions(options);
  };

  const alreadyExists = (value, list) => {
    const index = list.indexOf(value);

    return index != -1 ? true : false;
  };

  function getCtes(convocation) {
    setCte(null);
    setInvoices(null);

    if (convocation) {
      api
        .firestore()
        .collection('ctes')
        .where('convocation_id', '==', convocation.id)
        .onSnapshot(
          (snapshot) => {
            if (snapshot.docs.length > 0) {
              const selectedCte = snapshot.docs[0].data();
              const filteredInvoices = selectedCte.invoices.filter(
                (item) =>
                  (item.data != null &&
                    item.data.lat != null &&
                    item.data.lng != null) ||
                  (item.receiver != null &&
                    item.receiver.lat != null &&
                    item.receiver.lng != null)
              );

              setCte(selectedCte);
              setInvoices(filteredInvoices);
            } else {
              console.log('No such document!');
              setCte(null);
              setInvoices([]);
              if (error == null) {
                setError({ message: 'Erro ao procurar CTE!' });
              }
            }
          },
          (err) => {
            console.log('error:', err);
            setError(err);
          }
        );
    } else if (selectedConvocation) {
      api
        .firestore()
        .collection('ctes')
        .where('convocation_id', '==', selectedConvocation.id)
        .onSnapshot(
          (snapshot) => {
            if (snapshot.docs.length > 0) {
              const selectedCte = snapshot.docs[0].data();
              const filteredInvoices = selectedCte.invoices.filter(
                (item) =>
                  (item.data != null &&
                    item.data.lat != null &&
                    item.data.lng != null) ||
                  (item.receiver != null &&
                    item.receiver.lat != null &&
                    item.receiver.lng != null)
              );

              setCte(selectedCte);
              setInvoices(filteredInvoices);
            } else {
              console.log('No such document!');
              setCte(null);
              setInvoices([]);
              if (error == null) {
                setError({ message: 'Erro ao procurar CTE!' });
              }
            }
          },
          (err) => {
            console.log('error:', err);
            setError(err);
          }
        );
    }
  }

  const getUser = async () => {
    setUserPopover(null);

    if (selectedConvocation && selectedConvocation.driver) {
      api
        .firestore()
        .collection('users')
        .where('cpf', '==', selectedConvocation.driver)
        .get()
        .then((doc) => {
          if (doc.docs.length > 0) {
            const user = doc.docs[0].data();
            dispatch(TruckerActions.setSelectedTrucker(user));
          } else {
            console.log('No such document!');
            setUserPopover(null);
            dispatch(TruckerActions.setSelectedTrucker(null));
            if (error == null) {
              setError({ message: 'Erro ao procurar motorista!' });
            }
          }
        })
        .catch((error) => {
          console.log('Error getting document:', error);
          setUserPopover(null);
          dispatch(TruckerActions.setSelectedTrucker(null));
          console.log('error:', error);
          setError({ message: error });
        });
    }

    return null;
  };

  function calcDist(location1, location2) {
    let R = 6371;
    let dLat = (location2.lat - location1.lat) * (Math.PI / 180);
    let dLon = (location2.lng - location1.lng) * (Math.PI / 180);

    let a =
      Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos(location1.lat * (Math.PI / 180)) *
      Math.cos(location2.lat * (Math.PI / 180)) *
      Math.sin(dLon / 2) *
      Math.sin(dLon / 2);
    let c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    let d = R * c;

    return d;
  }

  const getPaths = async () => {
    try {
      setOpenErrorModal(false);
      setPaths(null);

      if (selectedConvocation && selectedConvocation.id) {
        api
          .firestore()
          .collection('location')
          .doc(`${selectedConvocation.id}`)
          .onSnapshot(
            async (snapshot) => {
              if (snapshot.exists) {
                const loc = snapshot
                  .data()
                  .user_location.filter(
                    (item) =>
                      item.latitude !== null &&
                      item.longitude !== null &&
                      item.createdAt.toDate() > new Date('2022-09-19')
                  );

                // const fixedPath = await fixPath(loc);
                // if (fixedPath.length > loc.length) {
                //   dispatch(
                //     ConvocationsActions.updateLocationRequest(
                //       fixedPath,
                //       loc,
                //       selectedConvocation
                //     )
                //   );
                // }

                const dirs = loc.map(
                  (item) =>
                  (item = {
                    lat: item.latitude ? item.latitude : item.lat,
                    lng: item.longitude ? item.longitude : item.lng,
                  })
                );

                console.log('dirs', dirs);

                setPaths(dirs);
                setOpenErrorModal(false);
              } else {
                console.log('No such document!');
                setPaths([]);
                setOpenErrorModal(true);
              }
            },
            (err) => {
              console.log('error:', err);
              if (error == null) {
                setError(err);
              }
            }
          );
      }
    } catch (error) {
      console.log('error:', error);
      setError({ message: error });
      return null;
    }
  };

  // const fixPath = async (filteredPath) => {
  //   let fixedPath = [];
  //   setLoading(true);

  //   console.log('filteredPath', filteredPath);

  //   for (let index = 0; index < filteredPath.length; index++) {
  //     const element = filteredPath[index];
  //     const afterElement =
  //       element != filteredPath[filteredPath.length - 1]
  //         ? filteredPath[index + 1]
  //         : null;

  //     fixedPath.push(element);

  //     if (
  //       afterElement != null &&
  //       calcDist(
  //         { lat: element.latitude, lng: element.longitude },
  //         {
  //           lat: afterElement.latitude,
  //           lng: afterElement.longitude,
  //         }
  //       ) > 0.1
  //     ) {
  //       const directionService = new window.google.maps.DirectionsService();

  //       directionService.route(
  //         {
  //           origin: new window.google.maps.LatLng(
  //             element.latitude,
  //             element.longitude
  //           ),
  //           destination: new window.google.maps.LatLng(
  //             afterElement.latitude,
  //             afterElement.longitude
  //           ),
  //           travelMode: window.google.maps.TravelMode.DRIVING,
  //         },
  //         (result, status) => {
  //           if (status === window.google.maps.DirectionsStatus.OK) {
  //             fixedPath = [...fixedPath, ...result.routes[0].overview_path];
  //             // console.log(index, result);
  //           } else {
  //             console.error(`error fetching directions ${result}`);
  //           }
  //         }
  //       );

  //       await sleep(1000);
  //     }
  //   }

  //   // console.log('fixedPath', fixedPath);

  //   setLoading(false);
  //   return fixedPath;
  // };

  function sleep(ms) {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }

  const handleDelete = () => {
    const convocationId = convocations.filter(
      (item) => item.id === selectedConvocation.id
    );

    const [convocation] = convocationId.map((item) => ({
      ...item,
    }));

    if (convocation.status !== 'initial') {
      alert.info(
        'Esta carga não pode ser excluida porque já esta em andamento!'
      );
    } else {
      dispatch(
        ConvocationsActions.updateConvocationRequest({
          ...convocation,
          status: 'canceled',
          validity: convocation.validity.seconds * 1000,
        })
      );
    }
  };

  const viewConvocation = (convocation) => {
    // Se a carga já está selecionada (mesmo ID), deselecionar (remover filtro)
    if (selectedConvocation && selectedConvocation.id === convocation.id) {
      setSelectedConvocation(null);
      return;
    }
    // Caso contrário, selecionar a carga (aplicar filtro)
    setSelectedConvocation(convocation);
  };

  const handleOpenFilter = () => {
    updateSelectorsOptions();
    setFilterOpen(true);
  };

  const handleCloseFilter = () => {
    setFiltered(false);
    setFilterOpen(false);
  };

  const handleOpenTruckerPopover = (event) => {
    setPopoverPosition(event.domEvent.currentTarget);
  };

  const handleCloseTruckerPopover = () => {
    setPopoverPosition(null);
  };

  const handleOpenMarkerPopover = (event, invoice) => {
    setMarkerPopoverPosition(event.domEvent.currentTarget);
    setSelectedInvoice(invoice);
  };

  const handleCloseMarkerPopover = () => {
    setMarkerPopoverPosition(null);
    setSelectedInvoice(null);
  };

  const toogleDrawer = () => {
    setOpenDrawer(!openDrawer);
  };

  /**
   * Limpar dados para serialização JSON
   */
  const limparDadosParaSerializacao = (obj, removerStringsVazias = false) => {
    if (obj === null || obj === undefined) {
      return undefined; // Retornar undefined para que seja removido
    }

    if (Array.isArray(obj)) {
      const cleaned = obj
        .map(item => limparDadosParaSerializacao(item, removerStringsVazias))
        .filter(item => item !== null && item !== undefined);
      return cleaned.length > 0 ? cleaned : undefined;
    }

    if (typeof obj === 'object') {
      const cleaned = {};
      for (const key in obj) {
        if (obj.hasOwnProperty(key)) {
          const value = limparDadosParaSerializacao(obj[key], removerStringsVazias);
          if (value !== null && value !== undefined) {
            if (removerStringsVazias && value === '') {
              continue;
            }
            // Não adicionar arrays vazios
            if (Array.isArray(value) && value.length === 0) {
              continue;
            }
            // Não adicionar objetos vazios
            if (typeof value === 'object' && !Array.isArray(value) && Object.keys(value).length === 0) {
              continue;
            }
            cleaned[key] = value;
          }
        }
      }
      return Object.keys(cleaned).length > 0 ? cleaned : undefined;
    }

    return obj;
  };

  /**
   * Função auxiliar para formatar IE (Inscrição Estadual)
   * Aceita: números (0-14 dígitos), "ISENTO" ou "PR" + 4-8 dígitos
   * Retorna string vazia se inválido (para não enviar o campo)
   */
  const formatarIE = (ie) => {
    if (!ie) return '';
    const ieStr = String(ie).trim().toUpperCase();
    if (!ieStr) return '';
    
    // Se for "ISENTO", manter
    if (ieStr === 'ISENTO') return 'ISENTO';
    
    // Se começar com "PR", manter formato "PR" + dígitos
    if (ieStr.startsWith('PR')) {
      const digitos = ieStr.replace(/\D/g, '').substring(2); // Remove "PR" e pega só dígitos
      if (digitos.length >= 4 && digitos.length <= 8) {
        return `PR${digitos}`;
      }
      // Se não tiver formato válido mas tiver dígitos, retornar apenas os dígitos
      if (digitos.length > 0 && digitos.length <= 14) {
        return digitos;
      }
      return '';
    }
    
    // Caso contrário, remover caracteres não numéricos e limitar a 14 dígitos
    const apenasNumeros = ieStr.replace(/\D/g, '');
    if (apenasNumeros.length > 0 && apenasNumeros.length <= 14) {
      return apenasNumeros;
    } else if (apenasNumeros.length > 14) {
      return apenasNumeros.substring(0, 14);
    }
    return '';
  };

  /**
   * Formatar placa no padrão: ^([A-Z]{2,3}[0-9]{4}|[A-Z]{3,4}[0-9]{3}|[A-Z0-9]{7})$
   * Aceita: ABC1234, ABC123, ABC1234D (Mercosul)
   */
  const formatarPlaca = (placa) => {
    if (!placa) return '';
    // Remove caracteres especiais e converte para maiúsculo
    const placaLimpa = String(placa).replace(/[^A-Z0-9]/gi, '').toUpperCase();
    if (!placaLimpa) return '';
    
    // Validar formato: 2-3 letras + 4 números OU 3-4 letras + 3 números OU 7 caracteres alfanuméricos
    const regexPlaca = /^([A-Z]{2,3}[0-9]{4}|[A-Z]{3,4}[0-9]{3}|[A-Z0-9]{7})$/;
    if (regexPlaca.test(placaLimpa)) {
      return placaLimpa;
    }
    
    // Se não passar na validação, retornar vazio (será validado depois)
    return placaLimpa;
  };

  /**
   * Mapear tipo de rodado para código numérico
   * 01 - Truck, 02 - Toco, 03 - Cavalo Mecânico, 04 - VAN, 05 - Utilitário, 06 - Outros
   */
  const mapearTipoRodado = (tipo) => {
    if (!tipo) return null;
    const tipoStr = String(tipo).trim();
    
    // Se já for um código numérico válido (01-06), retornar
    if (/^0[1-6]$/.test(tipoStr)) {
      return tipoStr;
    }
    
    // Mapear texto para código
    const mapeamento = {
      'TRUCK': '01',
      'Truck': '01',
      'truck': '01',
      'TOCO': '02',
      'Toco': '02',
      'toco': '02',
      'CAVALO MECANICO': '03',
      'Cavalo Mecânico': '03',
      'Cavalo Mecânico': '03',
      'CAVALO': '03',
      'Cavalo': '03',
      'VAN': '04',
      'Van': '04',
      'van': '04',
      'UTILITARIO': '05',
      'Utilitário': '05',
      'utilitário': '05',
      'UTILITARIO': '05',
      'OUTROS': '06',
      'Outros': '06',
      'outros': '06'
    };
    
    return mapeamento[tipoStr] || null;
  };

  /**
   * Mapear tipo de carroceria para código numérico
   * 00 - não aplicável, 01 - Aberta, 02 - Fechada/Baú, 03 - Granelera, 04 - Porta Container, 05 - Sider
   */
  const mapearTipoCarroceria = (tipo) => {
    if (!tipo) return null;
    const tipoStr = String(tipo).trim();
    
    // Se já for um código numérico válido (00-05), retornar
    if (/^0[0-5]$/.test(tipoStr)) {
      return tipoStr;
    }
    
    // Mapear texto para código
    const mapeamento = {
      'NAO APLICAVEL': '00',
      'Não Aplicável': '00',
      'não aplicável': '00',
      'ABERTA': '01',
      'Aberta': '01',
      'aberta': '01',
      'FECHADA/BAU': '02',
      'Fechada/Baú': '02',
      'fechada/baú': '02',
      'FECHADA': '02',
      'Fechada': '02',
      'BAU': '02',
      'Baú': '02',
      'baú': '02',
      'GRANELEIRA': '03',
      'Graneleira': '03',
      'graneleira': '03',
      'PORTA CONTAINER': '04',
      'Porta Container': '04',
      'porta container': '04',
      'SIDER': '05',
      'Sider': '05',
      'sider': '05'
    };
    
    return mapeamento[tipoStr] || null;
  };

  /**
   * Formatar RNTRC para exatamente 8 dígitos (preencher com zeros à esquerda)
   */
  const formatarRNTRC = (rntrc) => {
    if (!rntrc) return '';
    const rntrcLimpo = String(rntrc).replace(/\D/g, '');
    if (!rntrcLimpo) return '';
    
    // Preencher com zeros à esquerda até 8 dígitos
    return rntrcLimpo.padStart(8, '0').substring(0, 8);
  };

  /**
   * Preparar dados do MDF-e para envio à API Nuvem Fiscal
   */
  const prepararDadosMdfe = async (cargaId) => {
    try {
      // Buscar dados completos da carga
      const carga = await cargasAPI.buscarPorId(cargaId);

      if (!carga) {
        throw new Error('Carga não encontrada');
      }

      // Buscar viagens relacionadas através do campo carga_id
      // As viagens relacionadas à carga são aquelas que têm carga_id igual ao ID da carga
      const viagensCompletas = await viagensAPI.listar({ carga_id: cargaId });
      
      // Buscar motorista completo se houver CPF do motorista na carga
      let motoristaCompleto = null;
      if (carga.veiculos[0]?.motorista_cpf  ) {
        try {
          const cpfMotorista = (carga.veiculos[0]?.motorista_cpf).replace(/\D/g, '');
          if (cpfMotorista && cpfMotorista.length === 11) {
            motoristaCompleto = await truckersAPI.buscarPorCpf(cpfMotorista);
            console.log('✅ Motorista encontrado:', motoristaCompleto);
            console.log('✅ Veículos do motorista:', motoristaCompleto?.veiculos);
          }
        } catch (error) {
          console.warn('⚠️ Erro ao buscar motorista:', error);
          // Continuar sem motorista se não encontrar
        }
      }

      // Buscar seguro completo se houver selected_insurance_id
      let seguroCompleto = null;
      if (carga.selected_insurance_id) {
        try {
          seguroCompleto = await insurancesAPI.buscarPorId(carga.selected_insurance_id);
          console.log('✅ Seguro encontrado:', seguroCompleto);
        } catch (error) {
          console.warn('⚠️ Erro ao buscar seguro:', error);
          // Continuar sem seguro se não encontrar
        }
      }

      // O emitente do MDF-e deve ser a EMPRESA PRINCIPAL do sistema, não o solicitante
      // Buscar a empresa principal (primeira da lista ou a que tiver flag de principal)
      let empresaPrincipal = null;

      // Tentar encontrar empresa principal (com flag principal ou a primeira)
      if (providers && providers.length > 0) {
        empresaPrincipal = providers.find(p => p.principal === true || p.is_principal === true || p.main === true)
          || providers[0]; // Se não encontrar com flag, usar a primeira
      }

      // Se não encontrou no Redux, tentar buscar via API (listar todas e pegar a primeira)
      if (!empresaPrincipal) {
        try {
          const { providersAPI } = await import('services/apiRest');
          const empresasList = await providersAPI.listar();
          if (empresasList && empresasList.length > 0) {
            empresaPrincipal = empresasList.find(p => p.principal === true || p.is_principal === true || p.main === true)
              || empresasList[0];
          }
        } catch (error) {
          console.error('Erro ao buscar empresas:', error);
        }
      }

      // Se ainda não encontrou, tentar usar empresa_id da carga
      if (!empresaPrincipal && carga.empresa_id) {
        try {
          const { providersAPI } = await import('services/apiRest');
          empresaPrincipal = await providersAPI.buscarPorId(carga.empresa_id);
        } catch (error) {
          console.error('Erro ao buscar empresa por ID:', error);
        }
      }

      // Validar se temos dados mínimos do emitente (empresa principal)
      if (!empresaPrincipal) {
        throw new Error('Empresa principal (emitente) não encontrada. É necessário cadastrar pelo menos uma empresa no sistema.');
      }

      // Usar empresa principal como emitente
      const providerFinal = empresaPrincipal;

      console.log('📋 Empresa principal encontrada:', empresaPrincipal);
      console.log('📋 Empresa campos disponíveis:', Object.keys(empresaPrincipal || {}));
      console.log('📋 Carga campos disponíveis:', Object.keys(carga || {}));
      console.log('📋 Emitente final a ser usado:', providerFinal);

      // Formatar data de emissão no formato ISO 8601 com timezone (YYYY-MM-DDTHH:mm:ss-03:00)
      const agora = new Date();
      const offset = -3; // UTC-3 (Brasil)
      const dataBrasil = new Date(agora.getTime() + (offset * 60 * 60 * 1000));
      const dhEmi = dataBrasil.toISOString().replace('Z', `-0${Math.abs(offset)}:00`);

      // Formatar data de início da viagem
      let dhIniViagem = dhEmi;
      if (carga.data_inicio_viagem) {
        if (carga.data_inicio_viagem.includes('T')) {
          dhIniViagem = carga.data_inicio_viagem.includes('-03:00')
            ? carga.data_inicio_viagem
            : carga.data_inicio_viagem.replace('Z', '-03:00').replace(/(\+|-)\d{2}:\d{2}$/, '-03:00');
        } else {
          dhIniViagem = `${carga.data_inicio_viagem.split(' ')[0]}T00:00:00-03:00`;
        }
      }

      // Código UF (converter sigla para número)
      const CODIGOS_UF = {
        'AC': 12, 'AL': 27, 'AP': 16, 'AM': 13, 'BA': 29, 'CE': 23,
        'DF': 53, 'ES': 32, 'GO': 52, 'MA': 21, 'MT': 51, 'MS': 50,
        'MG': 31, 'PA': 15, 'PB': 25, 'PR': 41, 'PE': 26, 'PI': 22,
        'RJ': 33, 'RN': 24, 'RS': 43, 'RO': 11, 'RR': 14, 'SC': 42,
        'SP': 35, 'SE': 28, 'TO': 17
      };

      const obterCodigoUF = (uf) => {
        if (!uf) return 35; // SP como padrão
        const ufUpper = typeof uf === 'string' ? uf.toUpperCase() : uf;
        if (typeof ufUpper === 'object' && ufUpper.codigo_uf) {
          return parseInt(ufUpper.codigo_uf) || 35;
        }
        return CODIGOS_UF[ufUpper] || 35;
      };

      const cUF = obterCodigoUF(carga.uf_carregamento);
      const UFIni = typeof carga.uf_carregamento === 'string' ? carga.uf_carregamento : (carga.uf_carregamento?.sigla || '');
      const UFFim = typeof carga.uf_descarregamento === 'string' ? carga.uf_descarregamento : (carga.uf_descarregamento?.sigla || '');

      // Buscar último evento para reutilizar série e número se já foi emitido antes
      let ultimoEvento = null;
      try {
        ultimoEvento = await mdfeAPI.buscarUltimoEvento(carga.id);
        if (ultimoEvento) {
          console.log('📋 Último evento encontrado:', ultimoEvento);
          console.log('📋 Série do último evento:', ultimoEvento.serie);
          console.log('📋 Número do último evento:', ultimoEvento.numero);
        }
      } catch (error) {
        console.warn('⚠️ Erro ao buscar último evento (continuando com parâmetros SEFAZ):', error);
      }

      // Buscar parâmetros SEFAZ para número de série e número do MDF-e
      let parametrosSefaz = null;
      let serieMdfe = '1';
      let numeroMdfe = '1';
      
      // Se já foi emitido antes, reutilizar série e número do último evento
      if (ultimoEvento && ultimoEvento.serie && ultimoEvento.numero) {
        serieMdfe = String(ultimoEvento.serie);
        numeroMdfe = String(ultimoEvento.numero);
        console.log('✅ Reutilizando série e número do último evento emitido');
        console.log('📋 Série MDF-e (reutilizada):', serieMdfe);
        console.log('📋 Número MDF-e (reutilizado):', numeroMdfe);
      } else {
        // Se não foi emitido antes, buscar dos parâmetros SEFAZ
        try {
          const parametrosList = await sefazParamsAPI.listar();
          // Pegar o primeiro parâmetro (ou o que tiver flag de principal)
          parametrosSefaz = parametrosList && parametrosList.length > 0 
            ? (parametrosList.find(p => p.principal === true || p.is_principal === true) || parametrosList[0])
            : null;
          
          if (parametrosSefaz) {
            // Buscar número de série e número do MDF-e dos parâmetros
            serieMdfe = parametrosSefaz.serie_mdfe || parametrosSefaz.serie || carga.serie || '1';
            numeroMdfe = parametrosSefaz.numero_mdfe || parametrosSefaz.numero || carga.numero_mdfe || '1';
            
            console.log('📋 Parâmetros SEFAZ encontrados:', parametrosSefaz);
            console.log('📋 Série MDF-e:', serieMdfe);
            console.log('📋 Número MDF-e:', numeroMdfe);
          } else {
            console.warn('⚠️ Nenhum parâmetro SEFAZ encontrado, usando valores padrão');
          }
        } catch (error) {
          console.error('⚠️ Erro ao buscar parâmetros SEFAZ:', error);
          // Usar valores da carga como fallback
          serieMdfe = carga.serie || '1';
          numeroMdfe = carga.numero_mdfe || '1';
        }
      }

      // Extrair nome/razão social da empresa principal - usar os campos corretos
      const nomeRazaoSocial = providerFinal?.social_reason
        || providerFinal?.nome_razao_social
        || providerFinal?.razao_social
        || providerFinal?.nome
        || providerFinal?.name
        || providerFinal?.company_name
        || providerFinal?.corporate_name
        || providerFinal?.owner
        || providerFinal?.responsavel
        || '';

      // Extrair CNPJ/CPF da empresa principal
      const cpfCnpj = (providerFinal?.cnpj
        || providerFinal?.cpf
        || providerFinal?.cpf_cnpj
        || providerFinal?.document
        || '').replace(/\D/g, '');

      console.log('📋 Nome/Razão Social extraído:', nomeRazaoSocial);
      console.log('📋 CPF/CNPJ extraído:', cpfCnpj);
      console.log('📋 Provider final completo:', JSON.stringify(providerFinal, null, 2));

      // Se ainda não temos nome, lançar erro com informações de debug
      if (!nomeRazaoSocial || nomeRazaoSocial.trim() === '') {
        console.error('❌ Erro: Nome/Razão Social não encontrado');
        console.error('❌ Empresa principal:', JSON.ify(providerFinal, null, 2));
        console.error('❌ Todos os campos da empresa:', Object.keys(providerFinal || {}));
        throw new Error(`Nome/Razão Social do emitente não encontrado. Verifique se a empresa principal está cadastrada corretamente com os campos: nome, nome_razao_social ou razao_social.`);
      }

      // Se ainda não temos CPF/CNPJ, lançar erro
      if (!cpfCnpj || cpfCnpj.length < 11) {
        console.error('❌ Erro: CPF/CNPJ não encontrado ou inválido');
        console.error('❌ CPF/CNPJ extraído:', cpfCnpj);
        console.error('❌ Empresa principal:', JSON.stringify(providerFinal, null, 2));
        throw new Error(`CPF/CNPJ do emitente não encontrado ou inválido. Verifique se a empresa principal está cadastrada corretamente com os campos: cnpj ou cpf.`);
      }

      // Preparar dados no formato EXATO da API Nuvem Fiscal (infMDFe)
      // A chave principal é "infMDFe" conforme documentação da API Nuvem Fiscal
      const dadosMdfe = {
        infMDFe: {
          versao: '3.00',
          // Id deve seguir formato: MDFe + 44 dígitos numéricos
          Id: (() => {
            const cargaIdLimpo = carga.id.replace(/\D/g, '').substring(0, 44);
            const idCompleto = `MDFe${cargaIdLimpo.padEnd(44, '0')}`;
            return idCompleto;
          })(),

          ide: {
            cUF: cUF,
            tpAmb: carga.ambiente === 'producao' ? 1 : 2,
            tpEmit: 1,
            tpTransp: carga.transport_type === 'etc' ? 1 : (carga.transport_type === 'tac' ? 2 : (carga.transport_type === 'ctc' ? 3 : 2)),
            mod: 58,
            serie: parseInt(serieMdfe),
            nMDF: parseInt(numeroMdfe),
            // cMDF deve ter 8 dígitos numéricos (gerar aleatoriamente se não tiver)
            cMDF: (() => {
              const random = Math.floor(Math.random() * 100000000).toString().padStart(8, '0');
              return random;
            })(),
            cDV: 0,
            modal: 1, // 1 - Rodoviário (integer)
            dhEmi: dhEmi,
            tpEmis: 1,
            procEmi: '0',
            verProc: '1.0',
            UFIni: UFIni,
            UFFim: UFFim,
            infMunCarrega: [{
              cMunCarrega: String(carga.codigo_municipio_carregamento || '').replace(/\D/g, ''),
              xMunCarrega: String(carga.nome_municipio_carregamento || '').trim()
            }],
            infPercurso: carga.ufs_percurso?.map(uf => ({
              UFPer: typeof uf === 'string' ? uf : (uf?.sigla || '')
            })) || [],
            dhIniViagem: dhIniViagem,
            // indCanalVerde e indCarregaPosterior só devem ser enviados se forem 1
            ...(carga.indCanalVerde === 1 ? { indCanalVerde: 1 } : {}),
            ...(carga.indCarregaPosterior === 1 ? { indCarregaPosterior: 1 } : {}),
            // prodPred só é incluído se tpCarga e xProd estiverem preenchidos (ambos são required dentro de prodPred)
            // Usar tipo_carga ou cargo_type (fallback)
            ...((carga.tipo_carga || carga.cargo_type) && carga.descricao_produto ? {
              prodPred: {
                tpCarga: String(carga.tipo_carga || carga.cargo_type || '').trim(),
                xProd: String(carga.descricao_produto || '').trim()
              }
            } : {})
          },

          emit: {
            ...(cpfCnpj.length === 14 ? { CNPJ: cpfCnpj } : {}),
            ...(cpfCnpj.length === 11 ? { CPF: cpfCnpj } : {}),
            // IE pode ser: números (0-14 dígitos), "ISENTO" ou "PR" + 4-8 dígitos
            // IMPORTANTE: Se vazio, NÃO enviar o campo (o padrão regex permite string vazia, mas a API pode rejeitar)
            ...(providerFinal?.state_subscribe ? (() => {
              const ieOriginal = providerFinal.state_subscribe;
              const ieFormatado = formatarIE(ieOriginal);
              console.log('🔍 [IE Emitente] Original:', ieOriginal, 'Formatado:', ieFormatado);
              if (ieFormatado && ieFormatado.length > 0) {
                // Validar formato antes de enviar
                const regexIE = /^([0-9]{0,14}|ISENTO|PR[0-9]{4,8})$/;
                if (regexIE.test(ieFormatado)) {
                  console.log('✅ [IE Emitente] Válido:', ieFormatado);
                  return { IE: ieFormatado };
                } else {
                  console.error('❌ [IE Emitente] Formato inválido após formatação:', ieFormatado);
                }
              }
              console.log('⚠️ [IE Emitente] Não será enviado (vazio ou inválido)');
              return {};
            })() : {}),
            xNome: nomeRazaoSocial,
            ...(providerFinal?.fantasy_name && { xFant: providerFinal.fantasy_name }),
            enderEmit: {
              xLgr: String(providerFinal?.address || '').trim(),
              nro: String(providerFinal?.number || '').trim(),
              // xCpl deve ter pelo menos 1 caractere, usar espaço se vazio
              xCpl: String(providerFinal?.complement || ' ').trim() || ' ',
              xBairro: String(providerFinal?.neighborhood || '').trim(),
              cMun: String(providerFinal?.city_code || '').replace(/\D/g, ''),
              xMun: String(providerFinal?.city || '').trim(),
              CEP: String(providerFinal?.zipcode || '').replace(/\D/g, ''),
              UF: String(providerFinal?.state || '').trim().toUpperCase(),
              fone: String((providerFinal?.phone_ddd || '') + (providerFinal?.phone || '')).replace(/\D/g, ''),
              email: String(providerFinal?.email || '').trim()
            }
          },

          infModal: {
            versaoModal: '3.00',
            rodo: (() => {
              // Preparar veículos de tração e reboque
              // Priorizar veículos do motorista completo, senão usar veículos da carga
              let veiculosTracao = [];
              let veiculosReboque = [];
              
              if (motoristaCompleto?.veiculos && motoristaCompleto.veiculos.length > 0) {
                // Separar veículos de tração e reboque do motorista
                veiculosTracao = motoristaCompleto.veiculos.filter(v => v.tipo === 'tração');
                veiculosReboque = motoristaCompleto.veiculos.filter(v => v.tipo === 'reboque');
                console.log('✅ Usando veículos do motorista:', { tracao: veiculosTracao.length, reboque: veiculosReboque.length });
              } else if (carga.veiculos && carga.veiculos.length > 0) {
                // Fallback: usar veículos da carga (primeiro é tração, resto é reboque)
                veiculosTracao = [carga.veiculos[0]];
                veiculosReboque = carga.veiculos.slice(1);
                console.log('⚠️ Usando veículos da carga (fallback)');
              }

              // Preparar condutor (priorizar motorista completo)
              let condutores = [];
              if (motoristaCompleto) {
                condutores = [{
                  xNome: motoristaCompleto.name || motoristaCompleto.nome || '',
                  CPF: (motoristaCompleto.cpf || '').replace(/\D/g, '')
                }];
                console.log('✅ Usando condutor do motorista:', condutores);
              } else if (carga.condutores && carga.condutores.length > 0) {
                condutores = carga.condutores.map(cond => ({
                  xNome: cond.nome || '',
                  CPF: (cond.cpf || '').replace(/\D/g, '') || ''
                }));
                console.log('⚠️ Usando condutores da carga (fallback)');
              }

              // Preparar RNTRC (priorizar do motorista, senão da carga)
              // RNTRC deve ter exatamente 8 dígitos
              const rntrcRaw = (motoristaCompleto?.rntrc || carga.rntrc || '').replace(/\D/g, '');
              const rntrc = rntrcRaw.length >= 8 ? rntrcRaw.substring(0, 8) : rntrcRaw.padEnd(8, '0');

              // Preparar veículo de tração
              const veicTracao = veiculosTracao.length > 0 ? (() => {
                const veic = veiculosTracao[0];
                const cpfCnpjProp = String(veic.cpf_cnpj_proprietario || '').replace(/\D/g, '');
                const temProprietario = cpfCnpjProp || veic.nome_proprietario;
                
                // Formatar placa
                const placaFormatada = formatarPlaca(veic.placa);
                if (!placaFormatada) {
                  throw new Error(`Placa do veículo de tração inválida: "${veic.placa}". Formato esperado: ABC1234, ABC123 ou ABC1234D (Mercosul)`);
                }

                // Mapear tipo de rodado
                const tpRodMapeado = mapearTipoRodado(veic.tipo_rodado || veic.type_rotated || veic.tpRod);
                if (!tpRodMapeado) {
                  throw new Error(`Tipo de rodado inválido: "${veic.tipo_rodado || veic.type_rotated || veic.tpRod}". Valores aceitos: Truck, Toco, Cavalo Mecânico, VAN, Utilitário, Outros`);
                }

                // Mapear tipo de carroceria
                const tpCarMapeado = mapearTipoCarroceria(veic.tipo_carroceria || veic.type_bodywork || veic.tpCar);
                if (!tpCarMapeado) {
                  throw new Error(`Tipo de carroceria inválido: "${veic.tipo_carroceria || veic.type_bodywork || veic.tpCar}". Valores aceitos: Aberta, Fechada/Baú, Graneleira, Porta Container, Sider`);
                }

                // Formatar RNTRC do proprietário
                const rntrcPropFormatado = formatarRNTRC(veic.rntc || veic.RNTRC || veic.rntrc_proprietario);
                
                return {
                  placa: placaFormatada,
                  RENAVAM: String(veic.renavam || veic.RENAVAM || '').replace(/\D/g, ''),
                  tara: parseFloat(veic.tara_kg || veic.tara || 0) || 0,
                  capKG: parseFloat(veic.capacidade_kg || veic.capacity_kg || veic.capKG || 0) || 0,
                  capM3: parseFloat(veic.capacidade_m3 || veic.capacity_m3 || veic.capM3 || 0) || 0,
                  prop: temProprietario ? {
                    ...(cpfCnpjProp.length === 11 ? { CPF: cpfCnpjProp } : {}),
                    ...(cpfCnpjProp.length === 14 ? { CNPJ: cpfCnpjProp } : {}),
                    ...(rntrcPropFormatado ? { RNTRC: rntrcPropFormatado } : {}),
                    xNome: String(veic.nome_proprietario || veic.xNome || '').trim(),
                    // IE só enviar se tiver valor válido
                    ...(temProprietario ? (() => {
                      const ieOriginal = veic.ie_proprietario || veic.inscricao_estadual || veic.IE;
                      const ieFormatado = formatarIE(ieOriginal);
                      if (ieFormatado && ieFormatado.length > 0) {
                        // Validar formato antes de enviar
                        const regexIE = /^([0-9]{0,14}|ISENTO|PR[0-9]{4,8})$/;
                        if (regexIE.test(ieFormatado)) {
                          console.log('✅ [IE Veículo] Válido:', ieFormatado, 'de:', ieOriginal);
                          return { IE: ieFormatado };
                        } else {
                          console.error('❌ [IE Veículo] Formato inválido após formatação:', ieFormatado, 'de:', ieOriginal);
                        }
                      }
                      return {};
                    })() : {}),
                    tpProp: parseInt(veic.tpProp || veic.tipo_proprietario || 0) || 0
                  } : null,
                  condutor: condutores.length > 0 ? condutores : [],
                  tpRod: tpRodMapeado,
                  tpCar: tpCarMapeado,
                  UF: String(veic.uf_plate || veic.UF || veic.uf || '').toUpperCase()
                };
              })() : null;
              
              console.log('🔍 [Veículo de tração] Veículo:', veicTracao);
              // Preparar veículos de reboque
              const veicReboque = veiculosReboque.map(veic => {
                const cpfCnpjProp = String(veic.cpf_cnpj_proprietario || '').replace(/\D/g, '');
                const temProprietario = cpfCnpjProp || veic.nome_proprietario;
                
                // Formatar placa
                const placaFormatada = formatarPlaca(veic.placa);
                if (!placaFormatada) {
                  throw new Error(`Placa do veículo de reboque inválida: "${veic.placa}". Formato esperado: ABC1234, ABC123 ou ABC1234D (Mercosul)`);
                }

                // Mapear tipo de carroceria
                const tpCarMapeado = mapearTipoCarroceria(veic.tipo_carroceria || veic.type_bodywork || veic.tpCar);
                if (!tpCarMapeado) {
                  throw new Error(`Tipo de carroceria do reboque inválido: "${veic.tipo_carroceria || veic.type_bodywork || veic.tpCar}". Valores aceitos: Aberta, Fechada/Baú, Graneleira, Porta Container, Sider`);
                }

                // Formatar RNTRC do proprietário
                const rntrcPropFormatado = formatarRNTRC(veic.rntc || veic.RNTRC || veic.rntrc_proprietario);
                
                return {
                  cInt: String(veic.codigo_interno || veic.id || veic.codigo || ''),
                  placa: placaFormatada,
                  RENAVAM: String(veic.renavam || veic.RENAVAM || '').replace(/\D/g, ''),
                  tara: parseFloat(veic.tara_kg || veic.tara || 0) || 0,
                  capKG: parseFloat(veic.capacidade_kg || veic.capacity_kg || veic.capKG || 0) || 0,
                  capM3: parseFloat(veic.capacidade_m3 || veic.capacity_m3 || veic.capM3 || 0) || 0,
                  prop: temProprietario ? {
                    ...(cpfCnpjProp.length === 11 ? { CPF: cpfCnpjProp } : {}),
                    ...(cpfCnpjProp.length === 14 ? { CNPJ: cpfCnpjProp } : {}),
                    ...(rntrcPropFormatado ? { RNTRC: rntrcPropFormatado } : {}),
                    xNome: String(veic.nome_proprietario || veic.xNome || '').trim(),
                    // IE só enviar se tiver valor válido
                    ...(temProprietario ? (() => {
                      const ieOriginal = veic.ie_proprietario || veic.inscricao_estadual || veic.IE;
                      const ieFormatado = formatarIE(ieOriginal);
                      if (ieFormatado && ieFormatado.length > 0) {
                        // Validar formato antes de enviar
                        const regexIE = /^([0-9]{0,14}|ISENTO|PR[0-9]{4,8})$/;
                        if (regexIE.test(ieFormatado)) {
                          console.log('✅ [IE Veículo] Válido:', ieFormatado, 'de:', ieOriginal);
                          return { IE: ieFormatado };
                        } else {
                          console.error('❌ [IE Veículo] Formato inválido após formatação:', ieFormatado, 'de:', ieOriginal);
                        }
                      }
                      return {};
                    })() : {}),
                    tpProp: parseInt(veic.tpProp || veic.tipo_proprietario || 0) || 0
                  } : null,
                  tpCar: tpCarMapeado,
                  UF: String(veic.uf_plate || veic.UF || veic.uf || '').toUpperCase()
                };
              });

              // veicTracao é obrigatório
              if (!veicTracao) {
                throw new Error('Veículo de tração é obrigatório para modal rodoviário. Verifique se há veículos cadastrados para o motorista ou na carga.');
              }

              return {
                infANTT: {
                  RNTRC: rntrc,
                  infCIOT: carga.ciot ? [{
                    CIOT: carga.ciot.replace(/\D/g, ''),
                    CPF: motoristaCompleto?.cpf?.replace(/\D/g, '') || ''
                  }] : [],
                  valePed: null,
                  infContratante: [],
                  infPag: []
                },
                veicTracao: veicTracao,
                veicReboque: veicReboque.length > 0 ? veicReboque : [],
                lacRodo: []
              };
            })()
          },

          infDoc: {
            infMunDescarga: (() => {
              // Primeiro, tentar extrair municípios das viagens
              const municipiosDasViagens = viagensCompletas
                .map(viagem => {
                  const cMunDescarga = String(viagem.destinatario?.endereco?.codigo_municipio || viagem.destinatario?.endereco?.municipio?.codigo_ibge || '').replace(/\D/g, '');
                  
                  // Extrair nome do município (pode ser string ou objeto)
                  let xMunDescarga = '';
                  const municipio = viagem.destinatario?.endereco?.municipio;
                  if (typeof municipio === 'string') {
                    xMunDescarga = municipio.trim();
                  } else if (typeof municipio === 'object' && municipio !== null) {
                    xMunDescarga = String(municipio.descricao || municipio.nome || municipio.desc || municipio.name || '').trim();
                  } else {
                    xMunDescarga = String(viagem.destinatario?.endereco?.municipio_descricao || viagem.destinatario?.endereco?.municipio_nome || '').trim();
                  }

                  // Validar que cMunDescarga e xMunDescarga estão preenchidos (required)
                  if (!cMunDescarga || cMunDescarga.length !== 7 || !xMunDescarga || xMunDescarga.length < 2 || xMunDescarga.length > 60) {
                    return null; // Filtrar viagens sem município válido
                  }

                  return {
                    cMunDescarga: cMunDescarga,
                    xMunDescarga: xMunDescarga,
                    viagem: viagem // Manter referência para infCTe
                  };
                })
                .filter(item => item !== null);

              // Se não encontrou municípios nas viagens, usar os campos diretos da carga
              if (municipiosDasViagens.length === 0) {
                console.log('⚠️ Nenhum município encontrado nas viagens, tentando usar dados da carga...');

                // Tentar usar campos diretos da carga
                const cMunDescargaCarga = String(carga.codigo_municipio_descarregamento || '').replace(/\D/g, '');
                const xMunDescargaCarga = String(carga.nome_municipio_descarregamento || '').trim();

                console.log('📋 Campos diretos da carga:', { cMunDescargaCarga, xMunDescargaCarga });

                if (cMunDescargaCarga && cMunDescargaCarga.length === 7 && xMunDescargaCarga && xMunDescargaCarga.length >= 2 && xMunDescargaCarga.length <= 60) {
                  console.log('✅ Usando campos diretos da carga para infMunDescarga');
                  // Buscar NF-e das viagens relacionadas a este município
                  const nfesDoMunicipio = viagensCompletas
                    .filter(v => {
                      const cMunV = String(v.destinatario?.endereco?.codigo_municipio || v.destinatario?.endereco?.municipio?.codigo_ibge || '').replace(/\D/g, '');
                      return cMunV === cMunDescargaCarga && v.chave_nfe;
                    })
                    .map(v => ({
                      chNFe: String(v.chave_nfe || '').trim()
                    }));

                  return [{
                    cMunDescarga: cMunDescargaCarga,
                    xMunDescarga: xMunDescargaCarga,
                    infCTe: [],
                    infNFe: nfesDoMunicipio,
                    infMDFeTransp: []
                  }];
                }

                // Tentar usar municípios de descarregamento do JSONB municipios_carga ou municipios_descarga
                const municipiosDescarga = [{ codigo: carga.codigo_municipio_descarregamento, nome: carga.nome_municipio_descarregamento }];
                console.log('📋 Municípios do JSONB:', municipiosDescarga);

                if (Array.isArray(municipiosDescarga) && municipiosDescarga.length > 0) {
                  const municipiosValidos = municipiosDescarga
                    .map(mun => {
                      const cMun = String(mun.codigo || mun.codigo_ibge || '').replace(/\D/g, '');
                      
                      // Extrair nome do município (pode ser string ou objeto)
                      let xMun = '';
                      if (typeof mun.nome === 'string') {
                        xMun = mun.nome.trim();
                      } else if (typeof mun.nome === 'object' && mun.nome !== null) {
                        xMun = String(mun.nome.descricao || mun.nome.nome || mun.nome.desc || mun.nome.name || '').trim();
                      } else {
                        xMun = String(mun.nome || mun.descricao || mun.desc || '').trim();
                      }

                      console.log('📋 Processando município:', { cMun, xMun, mun });

                      if (cMun && cMun.length === 7 && xMun && xMun.length >= 2 && xMun.length <= 60) {
                        return {
                          cMunDescarga: cMun,
                          xMunDescarga: xMun
                        };
                      }
                      return null;
                    })
                    .filter(item => item !== null);

                  console.log('📋 Municípios válidos encontrados:', municipiosValidos.length);

                  if (municipiosValidos.length > 0) {
                    console.log('✅ Usando municípios do JSONB para infMunDescarga');
                    // Buscar NF-e das viagens relacionadas a estes municípios
                    return municipiosValidos.map(mun => {
                      const nfesDoMunicipio = viagensCompletas
                        .filter(v => {
                          const cMunV = String(v.destinatario?.endereco?.codigo_municipio || v.destinatario?.endereco?.municipio?.codigo_ibge || '').replace(/\D/g, '');
                          return cMunV === mun.cMunDescarga && v.chave_nfe;
                        })
                        .map(v => ({
                          chNFe: String(v.chave_nfe || '').trim()
                        }));

                      return {
                        ...mun,
                        infCTe: [],
                        infNFe: nfesDoMunicipio,
                        infMDFeTransp: []
                      };
                    });
                  }
                }

                // Se ainda não encontrou, retornar array vazio (será validado depois)
                console.warn('⚠️ Nenhum município de descarregamento encontrado na carga');
                return [];
              }

              // Se encontrou municípios nas viagens, montar com infCTe e infNFe
              return municipiosDasViagens.map(mun => {
                const viagem = mun.viagem;
                return {
                  cMunDescarga: mun.cMunDescarga,
                  xMunDescarga: mun.xMunDescarga,
                  infCTe: viagem?.chave_cte ? [{
                    chCTe: viagem.chave_cte,
                    SegCodBarra: '',
                    indReentrega: 0,
                    infUnidTransp: [],
                    peri: [],
                    infEntregaParcial: null,
                    indPrestacaoParcial: 0,
                    infNFePrestParcial: []
                  }] : [],
                  infNFe: viagem?.chave_nfe ? [{
                    chNFe: String(viagem.chave_nfe || '').trim()
                  }] : [],
                  infMDFeTransp: []
                };
              });
            })()
          },

          seg: (seguroCompleto || carga.selected_insurance_id) ? [{
            infResp: {
              respSeg: 1,
              ...(cpfCnpj.length === 14 ? { CNPJ: cpfCnpj } : {}),
              ...(cpfCnpj.length === 11 ? { CPF: cpfCnpj } : {})
            },
            infSeg: seguroCompleto ? {
              xSeg: seguroCompleto.nome_seguradora || seguroCompleto.nome || '',
              CNPJ: (seguroCompleto.cnpj_seguradora || seguroCompleto.cnpj || '').replace(/\D/g, '')
            } : {
              xSeg: carga.insurance?.nome || '',
              CNPJ: (carga.insurance?.cnpj || '').replace(/\D/g, '') || ''
            },
            nApol: seguroCompleto?.numero_apolice || carga.insurance?.numero_apolice || '',
            nAver: seguroCompleto?.numero_averbação ? [seguroCompleto.numero_averbação] : []
          }] : [],

          tot: {
            qCTe: viagensCompletas.filter(v => v.chave_cte).length,
            qNFe: viagensCompletas.filter(v => v.chave_nfe).length,
            qMDFe: 0,
            vCarga: parseFloat(carga.value || 0),
            cUnid: '01',
            qCarga: parseFloat(carga.quantidade_carga || 0)
          },

          lacres: [],
          autXML: [],
          // infAdic: infAdFisco e infCpl devem ter pelo menos 1 caractere se enviados
          // Só incluir infAdic se tiver pelo menos um campo preenchido
          ...((carga.infAdFisco && String(carga.infAdFisco).trim().length > 0) || (carga.observacoes && String(carga.observacoes).trim().length > 0) ? {
            infAdic: {
              ...(carga.infAdFisco && String(carga.infAdFisco).trim().length > 0 ? { infAdFisco: String(carga.infAdFisco).trim() } : {}),
              ...(carga.observacoes && String(carga.observacoes).trim().length > 0 ? { infCpl: String(carga.observacoes).trim() } : {})
            }
          } : {}),
          infRespTec: null,
          infSolicNFF: null
        },

        // infMDFeSupl.qrCodMDFe só deve ser enviado se tiver valor válido (pelo menos 50 caracteres)
        // NÃO enviar se estiver vazio ou tiver menos de 50 caracteres
        ...(carga.qrCodMDFe && String(carga.qrCodMDFe).trim().length >= 50 ? {
          infMDFeSupl: {
            qrCodMDFe: String(carga.qrCodMDFe).trim()
          }
        } : {})
      };

      // Adicionar ambiente e referencia DEPOIS do infMDFe (conforme estrutura da API)
      dadosMdfe.ambiente = carga.ambiente || 'homologacao';
      dadosMdfe.referencia = carga.id;

      // Validar campos obrigatórios antes de enviar
      if (!dadosMdfe.infMDFe?.ide?.dhEmi) {
        throw new Error('Data de emissão é obrigatória');
      }

      if (dadosMdfe.infMDFe?.ide?.modal !== 1) {
        throw new Error('Modal deve ser 1 (Rodoviário)');
      }

      if (!dadosMdfe.infMDFe?.emit || (!dadosMdfe.infMDFe.emit.CNPJ && !dadosMdfe.infMDFe.emit.CPF)) {
        throw new Error('CPF/CNPJ do emitente é obrigatório');
      }

      if (!dadosMdfe.infMDFe?.emit?.xNome || String(dadosMdfe.infMDFe.emit.xNome || '').trim() === '') {
        throw new Error('Nome/Razão Social do emitente é obrigatório');
      }

      // Validar infMunCarrega (required, Array [1..50])
      if (!dadosMdfe.infMDFe?.ide?.infMunCarrega || dadosMdfe.infMDFe.ide.infMunCarrega.length === 0) {
        throw new Error('infMunCarrega é obrigatório e deve conter pelo menos 1 município de carregamento');
      }

      if (dadosMdfe.infMDFe.ide.infMunCarrega.length > 50) {
        throw new Error('infMunCarrega não pode ter mais de 50 municípios');
      }

      // Validar infMunDescarga (required, Array [1..1000])
      console.log('📋 infMunDescarga preparado:', JSON.stringify(dadosMdfe.infMDFe?.infDoc?.infMunDescarga, null, 2));
      console.log('📋 Quantidade de municípios de descarregamento:', dadosMdfe.infMDFe?.infDoc?.infMunDescarga?.length || 0);
      console.log('📋 Campos da carga relacionados a descarregamento:', {
        codigo_municipio_descarregamento: carga.codigo_municipio_descarregamento,
        nome_municipio_descarregamento: carga.nome_municipio_descarregamento,
        municipios_carga: carga.municipios_carga,
        delivery_viagens: carga.delivery_viagens?.length || 0
      });

      if (!dadosMdfe.infMDFe?.infDoc?.infMunDescarga || dadosMdfe.infMDFe.infDoc.infMunDescarga.length === 0) {
        console.error('❌ Erro: infMunDescarga está vazio');
        console.error('❌ Viagens completas:', viagensCompletas.length);
        console.error('❌ Carga completa:', JSON.stringify(carga, null, 2));
        throw new Error('infMunDescarga é obrigatório e deve conter pelo menos 1 município de descarregamento. Verifique se a carga possui municípios de descarregamento cadastrados ou se as viagens relacionadas possuem destinatários com municípios válidos.');
      }

      if (dadosMdfe.infMDFe.infDoc.infMunDescarga.length > 1000) {
        throw new Error('infMunDescarga não pode ter mais de 1000 municípios');
      }

      // Validar prodPred se presente (tpCarga e xProd são required dentro de prodPred)
      if (dadosMdfe.infMDFe?.ide?.prodPred) {
        if (!dadosMdfe.infMDFe.ide.prodPred.tpCarga || String(dadosMdfe.infMDFe.ide.prodPred.tpCarga || '').trim() === '') {
          throw new Error('tpCarga é obrigatório quando prodPred está presente');
        }
        if (!dadosMdfe.infMDFe.ide.prodPred.xProd || String(dadosMdfe.infMDFe.ide.prodPred.xProd || '').trim() === '') {
          throw new Error('xProd é obrigatório quando prodPred está presente');
        }
      }

      // NÃO limpar dados - enviar exatamente como está
      // A API Nuvem Fiscal fará sua própria validação
      // Apenas remover null e undefined explícitos, mas manter strings vazias
      const limparApenasNull = (obj) => {
        if (obj === null || obj === undefined) {
          return undefined;
        }

        if (Array.isArray(obj)) {
          return obj.map(item => limparApenasNull(item)).filter(item => item !== undefined);
        }

        if (typeof obj === 'object') {
          const cleaned = {};
          for (const key in obj) {
            if (obj.hasOwnProperty(key)) {
              const value = limparApenasNull(obj[key]);
              if (value !== undefined) {
                cleaned[key] = value;
              }
            }
          }
          return cleaned;
        }

        return obj;
      };

      const dadosMdfeLimpos = limparApenasNull(dadosMdfe);

      // Garantir que estruturas obrigatórias sempre existam
      // Remover infMDFeSupl se qrCodMDFe estiver vazio ou tiver menos de 50 caracteres
      if (dadosMdfeLimpos.infMDFeSupl) {
        const qrCod = dadosMdfeLimpos.infMDFeSupl.qrCodMDFe;
        if (!qrCod || String(qrCod).trim().length < 50) {
          delete dadosMdfeLimpos.infMDFeSupl;
        }
      }

      // Garantir que enderEmit sempre tenha todos os campos obrigatórios (mesmo que vazios)
      if (dadosMdfeLimpos.infMDFe?.emit?.enderEmit) {
        const enderEmit = dadosMdfeLimpos.infMDFe.emit.enderEmit;
        enderEmit.xLgr = enderEmit.xLgr !== undefined ? enderEmit.xLgr : '';
        enderEmit.nro = enderEmit.nro !== undefined ? enderEmit.nro : '';
        enderEmit.xCpl = enderEmit.xCpl !== undefined ? enderEmit.xCpl : '';
        enderEmit.xBairro = enderEmit.xBairro !== undefined ? enderEmit.xBairro : '';
        enderEmit.cMun = enderEmit.cMun !== undefined ? enderEmit.cMun : '';
        enderEmit.xMun = enderEmit.xMun !== undefined ? enderEmit.xMun : '';
        enderEmit.CEP = enderEmit.CEP !== undefined ? enderEmit.CEP : '';
        enderEmit.UF = enderEmit.UF !== undefined ? enderEmit.UF : '';
        enderEmit.email = enderEmit.email !== undefined ? enderEmit.email : '';
      } else if (dadosMdfeLimpos.infMDFe?.emit) {
        // Se enderEmit não existir, criar com campos vazios
        dadosMdfeLimpos.infMDFe.emit.enderEmit = {
          xLgr: '',
          nro: '',
          xCpl: '',
          xBairro: '',
          cMun: '',
          xMun: '',
          CEP: '',
          UF: '',
          email: ''
        };
      }

      // Garantir que IE sempre esteja presente no emitente
      if (dadosMdfeLimpos.infMDFe?.emit) {
        if (dadosMdfeLimpos.infMDFe.emit.IE === undefined) {
          dadosMdfeLimpos.infMDFe.emit.IE = '';
        }
      }

      // Garantir que infMunCarrega sempre seja um array
      if (!dadosMdfeLimpos.infMDFe?.ide?.infMunCarrega) {
        dadosMdfeLimpos.infMDFe.ide.infMunCarrega = [];
      }

      // Log detalhado do emitente
      console.log('📋 Emitente completo:', JSON.stringify(dadosMdfeLimpos.infMDFe?.emit, null, 2));
      console.log('📋 enderEmit completo:', JSON.stringify(dadosMdfeLimpos.infMDFe?.emit?.enderEmit, null, 2));
      console.log('📋 infMunCarrega:', JSON.stringify(dadosMdfeLimpos.infMDFe?.ide?.infMunCarrega, null, 2));

      console.log('📦 Dados do MDF-e preparados (COMPLETO):', JSON.stringify(dadosMdfeLimpos, null, 2));
      console.log('✅ Validações locais passaram:', {
        dhEmi: dadosMdfeLimpos.infMDFe?.ide?.dhEmi,
        modal: dadosMdfeLimpos.infMDFe?.ide?.modal,
        emitente_cpf_cnpj: dadosMdfeLimpos.infMDFe?.emit?.CNPJ || dadosMdfeLimpos.infMDFe?.emit?.CPF,
        emitente_nome: dadosMdfeLimpos.infMDFe?.emit?.xNome,
        emitente_IE: dadosMdfeLimpos.infMDFe?.emit?.IE,
        emitente_IE_tipo: typeof dadosMdfeLimpos.infMDFe?.emit?.IE,
        emitente_IE_length: dadosMdfeLimpos.infMDFe?.emit?.IE ? String(dadosMdfeLimpos.infMDFe.emit.IE).length : 0,
        enderEmit_xLgr: dadosMdfeLimpos.infMDFe?.emit?.enderEmit?.xLgr,
        enderEmit_nro: dadosMdfeLimpos.infMDFe?.emit?.enderEmit?.nro,
        enderEmit_cMun: dadosMdfeLimpos.infMDFe?.emit?.enderEmit?.cMun,
        enderEmit_xMun: dadosMdfeLimpos.infMDFe?.emit?.enderEmit?.xMun,
        enderEmit_UF: dadosMdfeLimpos.infMDFe?.emit?.enderEmit?.UF,
        enderEmit_email: dadosMdfeLimpos.infMDFe?.emit?.enderEmit?.email,
        infMunCarrega_count: dadosMdfeLimpos.infMDFe?.ide?.infMunCarrega?.length || 0
      });

      // Adicionar carga_id e referencia no objeto retornado para gravar evento
      return {
        ...dadosMdfeLimpos,
        carga_id: cargaId,
        referencia: cargaId
      };
    } catch (error) {
      console.error('Erro ao preparar dados do MDF-e:', error);
      throw new Error(`Erro ao buscar dados da carga: ${error.message}`);
    }
  };

  /**
   * Emitir MDF-e
   */
  const handleEmitirMdfe = async (carga) => {
    try {
      console.log('🚀 [handleEmitirMdfe] Iniciando emissão do MDF-e para carga:', carga.id);
      
      dispatch(
        toastrActions.add({
          type: 'info',
          title: 'Processando',
          message: 'Preparando emissão do MDF-e...',
        })
      );

      // Buscar último evento antes de preparar dados para verificar se está reutilizando número
      let ultimoEventoMdfe = null;
      try {
        ultimoEventoMdfe = await mdfeAPI.buscarUltimoEvento(carga.id);
        if (ultimoEventoMdfe && ultimoEventoMdfe.serie && ultimoEventoMdfe.numero) {
          console.log('📋 [handleEmitirMdfe] Último evento encontrado, será reutilizado série e número');
        }
      } catch (error) {
        console.warn('⚠️ [handleEmitirMdfe] Erro ao buscar último evento:', error);
      }

      // Preparar dados do MDF-e
      console.log('📋 [handleEmitirMdfe] Preparando dados do MDF-e...');
      console.log('📋 [handleEmitirMdfe] ID da carga:', carga.id);
      const dadosMdfe = await prepararDadosMdfe(carga.id);
      console.log('✅ [handleEmitirMdfe] Dados do MDF-e preparados com sucesso');
      console.log('📋 [handleEmitirMdfe] carga_id incluído:', dadosMdfe.carga_id);
      console.log('📋 [handleEmitirMdfe] referencia incluída:', dadosMdfe.referencia);
      console.log('📋 [handleEmitirMdfe] Verificando estrutura completa do payload...');
      console.log('📋 [handleEmitirMdfe] Keys do objeto dadosMdfe:', Object.keys(dadosMdfe));

      // Enviar para a API
      console.log('📤 [handleEmitirMdfe] Enviando dados para a API...');
      console.log('📤 [handleEmitirMdfe] Payload completo (primeiros 2000 chars):', JSON.stringify(dadosMdfe, null, 2).substring(0, 2000));
      const resultado = await mdfeAPI.emitir(dadosMdfe);
      console.log('✅ [handleEmitirMdfe] MDF-e emitido com sucesso:', resultado);

      // Incrementar número do MDF-e nos parâmetros SEFAZ após emissão bem-sucedida
      // APENAS se não estiver reutilizando número anterior
      const estavaReutilizando = ultimoEventoMdfe && ultimoEventoMdfe.serie && ultimoEventoMdfe.numero;
      if (!estavaReutilizando) {
        try {
          console.log('🔄 [handleEmitirMdfe] Incrementando número do MDF-e nos parâmetros SEFAZ...');
          await sefazParamsAPI.incrementarNumero('mdfe');
          console.log('✅ [handleEmitirMdfe] Número do MDF-e incrementado nos parâmetros SEFAZ');
        } catch (error) {
          console.error('⚠️ [handleEmitirMdfe] Erro ao incrementar número do MDF-e:', error);
          // Não bloquear o fluxo se falhar ao incrementar
          dispatch(
            toastrActions.add({
              type: 'warning',
              title: 'Aviso',
              message: 'MDF-e emitido, mas houve um problema ao atualizar o número sequencial',
            })
          );
        }
      } else {
        console.log('ℹ️ [handleEmitirMdfe] Número sequencial NÃO incrementado (reutilizando número anterior)');
      }

      dispatch(
        toastrActions.add({
          type: 'success',
          title: 'Sucesso',
          message: resultado?.mensagem || resultado?.message || 'MDF-e transmitido com sucesso!',
        })
      );

      // Recarregar lista de cargas
      console.log('🔄 [handleEmitirMdfe] Recarregando lista de cargas...');
      dispatch(ConvocationsActions.getConvocationsRequest());

      return resultado;
    } catch (error) {
      console.error('❌ [handleEmitirMdfe] Erro ao emitir MDF-e:', error);
      console.error('❌ [handleEmitirMdfe] Stack trace:', error.stack);
      
      // Extrair mensagem de erro mais detalhada
      let errorMessage = 'Erro desconhecido ao emitir MDF-e';
      if (error.message) {
        errorMessage = error.message;
      } else if (error.response?.data?.erro) {
        errorMessage = error.response.data.erro;
      } else if (error.response?.data?.detalhes) {
        errorMessage = error.response.data.detalhes;
      } else if (typeof error === 'string') {
        errorMessage = error;
      }

      dispatch(
        toastrActions.add({
          type: 'error',
          title: 'Erro ao emitir MDF-e',
          message: errorMessage,
        })
      );
      throw error;
    }
  };

  /**
   * Consultar MDF-e - Abre modal com eventos
   */
  const handleConsultarMdfe = async (carga) => {
    try {
      // Abrir modal de eventos
      setSelectedCargaIdMdfe(carga.id);
      setOpenModalEventosMdfe(true);
    } catch (error) {
      dispatch(
        toastrActions.add({
          type: 'error',
          title: 'Erro ao abrir eventos do MDF-e',
          message: error.message || 'Erro desconhecido',
        })
      );
    }
  };

  /**
   * Abrir modal de cancelamento do MDF-e
   */
  const handleCancelarMdfe = (carga) => {
    setCargaParaCancelar(carga);
    setOpenModalJustificativaCancelamentoMdfe(true);
  };

  /**
   * Confirmar cancelamento do MDF-e com justificativa
   */
  const handleConfirmarCancelamentoMdfe = async (justificativa) => {
    try {
      if (!cargaParaCancelar) {
        throw new Error('Carga não encontrada para cancelamento');
      }

      if (!justificativa || justificativa.trim().length < 15) {
        throw new Error('Justificativa deve ter no mínimo 15 caracteres');
      }

      dispatch(
        toastrActions.add({
          type: 'info',
          title: 'Processando',
          message: 'Cancelando MDF-e...',
        })
      );

      const ultimoEvento = await mdfeAPI.buscarUltimoEvento(cargaParaCancelar.id);
      
      // Validação: verificar se existe evento e se foi transmitido
      if (!ultimoEvento) {
        throw new Error('MDF-e não encontrado para esta carga. Por favor, emita o MDF-e primeiro.');
      }
      
      if (!ultimoEvento.mdfe_id) {
        throw new Error('MDF-e ainda não foi transmitido. Aguarde a transmissão ou emita novamente.');
      }

      const resultado = await mdfeAPI.cancelar(ultimoEvento.mdfe_id, justificativa.trim());

      dispatch(
        toastrActions.add({
          type: 'success',
          title: 'Sucesso',
          message: 'MDF-e cancelado com sucesso!',
        })
      );

      // Fechar modal e limpar estado
      setOpenModalJustificativaCancelamentoMdfe(false);
      setCargaParaCancelar(null);

      dispatch(ConvocationsActions.getConvocationsRequest());
      return resultado;
    } catch (error) {
      dispatch(
        toastrActions.add({
          type: 'error',
          title: 'Erro ao cancelar MDF-e',
          message: error.message || 'Erro desconhecido',
        })
      );
      throw error;
    }
  };

  /**
   * Abrir modal de encerramento do MDF-e
   */
  const handleEncerrarMdfe = (carga) => {
    setCargaParaEncerrar(carga);
    setOpenModalEncerramentoMdfe(true);
  };

  /**
   * Confirmar encerramento do MDF-e com dados
   */
  const handleConfirmarEncerramentoMdfe = async (dadosEncerramento) => {
    try {
      if (!cargaParaEncerrar) {
        throw new Error('Carga não encontrada para encerramento');
      }

      dispatch(
        toastrActions.add({
          type: 'info',
          title: 'Processando',
          message: 'Encerrando MDF-e...',
        })
      );

      const ultimoEvento = await mdfeAPI.buscarUltimoEvento(cargaParaEncerrar.id);
      
      // Validação: verificar se existe evento e se foi transmitido
      if (!ultimoEvento) {
        throw new Error('MDF-e não encontrado para esta carga. Por favor, emita o MDF-e primeiro.');
      }
      
      if (!ultimoEvento.mdfe_id) {
        throw new Error('MDF-e ainda não foi transmitido. Aguarde a transmissão ou emita novamente.');
      }

      const resultado = await mdfeAPI.encerrar(ultimoEvento.mdfe_id, dadosEncerramento);

      dispatch(
        toastrActions.add({
          type: 'success',
          title: 'Sucesso',
          message: 'MDF-e encerrado com sucesso!',
        })
      );

      // Fechar modal e limpar estado
      setOpenModalEncerramentoMdfe(false);
      setCargaParaEncerrar(null);

      dispatch(ConvocationsActions.getConvocationsRequest());
      return resultado;
    } catch (error) {
      dispatch(
        toastrActions.add({
          type: 'error',
          title: 'Erro ao encerrar MDF-e',
          message: error.message || 'Erro desconhecido',
        })
      );
      throw error;
    }
  };

  /**
   * Baixar PDF do MDF-e
   */
  const handleBaixarPdfMdfe = async (carga) => {
    try {
      dispatch(
        toastrActions.add({
          type: 'info',
          title: 'Processando',
          message: 'Baixando PDF do MDF-e...',
        })
      );

      const ultimoEvento = await mdfeAPI.buscarUltimoEvento(carga.id);
      
      // Validação: verificar se existe evento e se foi transmitido
      if (!ultimoEvento) {
        throw new Error('MDF-e não encontrado para esta carga. Por favor, emita o MDF-e primeiro.');
      }
      
      if (!ultimoEvento.mdfe_id) {
        throw new Error('MDF-e ainda não foi transmitido. Aguarde a transmissão ou emita novamente.');
      }

      const blob = await mdfeAPI.baixarPdf(ultimoEvento.mdfe_id);
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = `MDFe-${carga.id}.pdf`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);

      dispatch(
        toastrActions.add({
          type: 'success',
          title: 'Sucesso',
          message: 'PDF baixado com sucesso!',
        })
      );
    } catch (error) {
      dispatch(
        toastrActions.add({
          type: 'error',
          title: 'Erro ao baixar PDF',
          message: error.message || 'Erro desconhecido',
        })
      );
      throw error;
    }
  };

  /**
   * Baixar XML do MDF-e
   */
  const handleBaixarXmlMdfe = async (carga) => {
    try {
      dispatch(
        toastrActions.add({
          type: 'info',
          title: 'Processando',
          message: 'Baixando XML do MDF-e...',
        })
      );

      const ultimoEvento = await mdfeAPI.buscarUltimoEvento(carga.id);
      
      // Validação: verificar se existe evento e se foi transmitido
      if (!ultimoEvento) {
        throw new Error('MDF-e não encontrado para esta carga. Por favor, emita o MDF-e primeiro.');
      }
      
      if (!ultimoEvento.mdfe_id) {
        throw new Error('MDF-e ainda não foi transmitido. Aguarde a transmissão ou emita novamente.');
      }

      const blob = await mdfeAPI.baixarXml(ultimoEvento.mdfe_id);
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = `MDFe-${carga.id}.xml`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);

      dispatch(
        toastrActions.add({
          type: 'success',
          title: 'Sucesso',
          message: 'XML baixado com sucesso!',
        })
      );
    } catch (error) {
      dispatch(
        toastrActions.add({
          type: 'error',
          title: 'Erro ao baixar XML',
          message: error.message || 'Erro desconhecido',
        })
      );
      throw error;
    }
  };

  /**
   * Sincronizar MDF-e
   */
  const handleSincronizarMdfe = async (carga) => {
    try {
      dispatch(
        toastrActions.add({
          type: 'info',
          title: 'Processando',
          message: 'Sincronizando MDF-e...',
        })
      );

      const ultimoEvento = await mdfeAPI.buscarUltimoEvento(carga.id);
      
      // Validação: verificar se existe evento e se foi transmitido
      if (!ultimoEvento) {
        throw new Error('MDF-e não encontrado para esta carga. Por favor, emita o MDF-e primeiro.');
      }
      
      if (!ultimoEvento.mdfe_id) {
        throw new Error('MDF-e ainda não foi transmitido. Aguarde a transmissão ou emita novamente.');
      }

      const resultado = await mdfeAPI.sincronizar(ultimoEvento.mdfe_id);

      dispatch(
        toastrActions.add({
          type: 'success',
          title: 'Sucesso',
          message: 'MDF-e sincronizado com sucesso!',
        })
      );

      dispatch(ConvocationsActions.getConvocationsRequest());
      return resultado;
    } catch (error) {
      dispatch(
        toastrActions.add({
          type: 'error',
          title: 'Erro ao sincronizar MDF-e',
          message: error.message || 'Erro desconhecido',
        })
      );
      throw error;
    }
  };

  const tooglePercurseLogs = (convocation) => {
    getCtes(convocation);
    setPercurseLogs(convocation);
  };
  const { modalDelete, messageModal, acceptDelete, modalShare } = useSelector(
    (state) => state.convocations
  );

  const openTruckerPopover = Boolean(popoverPosition);
  const openMarkerPopover = Boolean(markerPopoverPosition);

  // Buscar cargas quando o componente monta
  useEffect(() => {
    dispatch(ConvocationsActions.getConvocationsRequest());
  }, [dispatch]);

  // Removido - lógica consolidada no useEffect principal

  // Buscar todas as viagens não encerradas quando não há carga selecionada
  useEffect(() => {
    if (!selectedConvocation) {
      viagensAPI.listar({})
        .then((viagens) => {
          if (viagens && viagens.length > 0) {
            // Filtrar apenas viagens não encerradas
            const activeTrips = viagens.filter((viagem) => {
              const status = viagem.status || '';
              const statusLower = String(status).toLowerCase();
              return statusLower !== 'encerrada' && statusLower !== 'completed' && statusLower !== 'finalizada';
            });
            setAllActiveTrips(activeTrips);

            // Buscar últimas localizações de rastreamento de TODAS as cargas (não apenas as relacionadas a viagens)
            rastreamentoAPI.buscarUltimasLocalizacoesTodasCargas()
              .then((todasLocalizacoes) => {
                console.log(`📍 [Convocations] Total de localizações encontradas: ${todasLocalizacoes.length}`);
                
                // Filtrar e normalizar os dados
                const trackingDataFiltered = todasLocalizacoes
                  .filter(track => {
                    if (!track) return false;
                    const lat = parseFloat(track.latitude || track.lat || 0);
                    const lng = parseFloat(track.longitude || track.lng || 0);
                    return !isNaN(lat) && !isNaN(lng) && lat !== 0 && lng !== 0 &&
                           lat >= -35 && lat <= 6 && lng >= -75 && lng <= -30;
                  })
                  .map(track => ({
                    ...track,
                    latitude: parseFloat(track.latitude || track.lat),
                    longitude: parseFloat(track.longitude || track.lng),
                  }));
                
                console.log(`✅ [Convocations] ${trackingDataFiltered.length} localizações válidas`);
                setAllTrackingData(trackingDataFiltered);
              })
              .catch((error) => {
                console.error('❌ [Convocations] Erro ao buscar localizações:', error);
                setAllTrackingData([]);
              });
          } else {
            setAllActiveTrips([]);
            setAllTrackingData([]);
          }
        })
        .catch((error) => {
          console.error('❌ [Convocations] Erro ao buscar viagens ativas:', error);
          setAllActiveTrips([]);
          setAllTrackingData([]);
        });
    } else {
      // Limpar viagens ativas quando uma carga é selecionada
      setAllActiveTrips([]);
      setAllTrackingData([]);
    }
  }, [selectedConvocation]);

  useEffect(() => {
    if (selectedConvocation) {
      getPaths();
      getCtes();
      getUser();

      // Buscar viagens relacionadas à carga (independente do status quando selecionada)
      if (selectedConvocation.id) {
        viagensAPI.listar({ carga_id: selectedConvocation.id })
          .then((viagens) => {
            if (viagens && viagens.length > 0) {
              setRelatedTrips(viagens); // Todas as viagens da carga, independente do status
            } else {
              setRelatedTrips([]);
            }
          })
          .catch((error) => {
            console.error('❌ [Convocations] Erro ao buscar viagens relacionadas:', error);
            setRelatedTrips([]);
          });

        // Buscar última localização de rastreamento da carga selecionada
        rastreamentoAPI.buscarUltimaLocalizacao(selectedConvocation.id)
          .then((ultimaLocalizacao) => {
            console.log(`🔍 [Convocations] Resultado da busca para carga ${selectedConvocation.id}:`, ultimaLocalizacao);
            
            if (ultimaLocalizacao) {
              // Normalizar campos de latitude/longitude
              const lat = ultimaLocalizacao.latitude || ultimaLocalizacao.lat;
              const lng = ultimaLocalizacao.longitude || ultimaLocalizacao.lng;
              
              if (lat && lng) {
                const latNum = parseFloat(lat);
                const lngNum = parseFloat(lng);
                
                // Validar coordenadas
                if (!isNaN(latNum) && !isNaN(lngNum) && latNum !== 0 && lngNum !== 0) {
                  // Validar se está dentro de limites razoáveis (Brasil)
                  if (latNum >= -35 && latNum <= 6 && lngNum >= -75 && lngNum <= -30) {
                    const trackingData = {
                      ...ultimaLocalizacao,
                      carga_id: selectedConvocation.id,
                      latitude: latNum,
                      longitude: lngNum,
                    };
                    console.log(`✅ [Convocations] Localização válida encontrada para carga ${selectedConvocation.id}:`, trackingData);
                    setFilteredTrackingData([trackingData]);
                  } else {
                    console.log(`⚠️ [Convocations] Coordenadas fora dos limites do Brasil para carga ${selectedConvocation.id}:`, { lat: latNum, lng: lngNum });
                    setFilteredTrackingData([]);
                  }
                } else {
                  console.log(`⚠️ [Convocations] Coordenadas inválidas para carga ${selectedConvocation.id}:`, { lat, lng });
                  setFilteredTrackingData([]);
                }
              } else {
                console.log(`⚠️ [Convocations] Carga ${selectedConvocation.id} sem coordenadas válidas. Dados:`, ultimaLocalizacao);
                setFilteredTrackingData([]);
              }
            } else {
              console.log(`⚠️ [Convocations] Nenhuma localização de rastreamento para carga ${selectedConvocation.id}`);
              setFilteredTrackingData([]);
            }
          })
          .catch((error) => {
            console.log(`⚠️ [Convocations] Carga ${selectedConvocation.id} sem rastreamento disponível:`, error.message);
            setFilteredTrackingData([]);
          });
      } else {
        setRelatedTrips([]);
        setFilteredTrackingData([]);
      }
    } else {
      setRelatedTrips([]);
      setFilteredTrackingData([]);
    }
  }, [selectedConvocation]);

  useEffect(() => {
    // Atualizar filteredData sempre que convocations ou search mudarem
    console.log('🔄 useEffect convocations atualizado:', {
      totalConvocations: convocations?.length || 0,
      search,
      timestamp: new Date().toISOString()
    });
    
    if (convocations) {
      setPageLoading(true);
      
      // Mapear dados básicos primeiro (síncrono e rápido)
      const mappedData = convocations.map((item) => ({
        ...item,
        actions: item.id,
        id: item.id,
        requester: item.owner,
        type: item.type,
        created_at: item.created_at ? item.created_at.seconds * 1000 : '',
        validity: item.validity ? item.validity.seconds * 1000 : '',
        documentoStatus: null, // Será preenchido depois se necessário
        destinatarioNome: item.delivery_corresponding || null, // Fallback inicial
      }));
      
      console.log('📦 Dados mapeados:', {
        total: mappedData.length,
        primeiroItem: mappedData[0] ? {
          id: mappedData[0].id,
          requester: mappedData[0].requester,
          destinatarioNome: mappedData[0].destinatarioNome,
          delivery_corresponding: mappedData[0].delivery_corresponding
        } : null
      });

      // Filtrar dados primeiro (mostrar imediatamente)
      const filtered = mappedData.filter(
        (item) =>
          (item.requester || '').toUpperCase().includes(search.toUpperCase()) ||
          (item.type || '').toUpperCase().includes(search.toUpperCase())
      );
      
      // Mostrar dados imediatamente (sem esperar busca de destinatários)
      setFilteredData(filtered);
      setPageLoading(false);

      // Buscar destinatários das viagens em background (não bloqueia a renderização)
      const buscarDestinatarios = async () => {
        try {
          const cargaIds = mappedData.map(item => item.id).filter(Boolean);
          
          if (cargaIds.length === 0) {
            console.log('⚠️ Nenhuma carga encontrada para buscar destinatários');
            return;
          }

          console.log(`🔍 Buscando destinatários para ${cargaIds.length} cargas:`, cargaIds);

          // Buscar todas as viagens relacionadas em uma única query otimizada
          // Adicionar timestamp para evitar cache
          let todasViagens = [];
          try {
            todasViagens = await viagensAPI.listar({ 
              carga_ids: cargaIds,
              _t: Date.now() // Evitar cache
            });
            console.log(`✅ Buscadas ${todasViagens.length} viagens para ${cargaIds.length} cargas`);
            
            // Log das viagens encontradas para debug
            if (todasViagens.length > 0) {
              console.log('📋 Primeira viagem encontrada:', {
                id: todasViagens[0].id,
                carga_id: todasViagens[0].carga_id,
                destinatario: todasViagens[0].destinatario,
                destinatario_nome: todasViagens[0].destinatario_nome
              });
            }
          } catch (error) {
            console.error('❌ Erro ao buscar viagens:', error);
            console.error('❌ Stack:', error.stack);
            return;
          }

          // Criar mapa de carga_id -> destinatário
          const destinatariosMap = {};
          todasViagens.forEach(viagem => {
            if (viagem.carga_id) {
              // Tentar várias formas de obter o nome do destinatário
              const nomeDestinatario = 
                viagem.destinatario?.nome_razao_social || 
                viagem.destinatario?.nome ||
                viagem.destinatario_nome ||
                viagem.destinatario_nome_razao_social ||
                null;
              
              // Sempre atualizar (não apenas se não existir) para garantir dados frescos
              if (nomeDestinatario) {
                destinatariosMap[viagem.carga_id] = nomeDestinatario;
                console.log(`✅ Destinatário encontrado para carga ${viagem.carga_id}: ${nomeDestinatario}`);
              } else {
                console.warn(`⚠️ Viagem ${viagem.id} (carga_id: ${viagem.carga_id}) não tem destinatário:`, {
                  temDestinatario: !!viagem.destinatario,
                  destinatario: viagem.destinatario,
                  destinatario_nome: viagem.destinatario_nome
                });
              }
            }
          });
          
          console.log(`📊 Mapa de destinatários criado (${Object.keys(destinatariosMap).length} destinatários):`, destinatariosMap);

          // Atualizar apenas os destinatários encontrados
          if (Object.keys(destinatariosMap).length > 0) {
            setFilteredData(prevData => 
              prevData.map(item => {
                const novoDestinatario = destinatariosMap[item.id];
                // Sempre atualizar se encontrou um destinatário novo
                if (novoDestinatario) {
                  return { ...item, destinatarioNome: novoDestinatario };
                }
                // Manter o fallback se não encontrou
                return item;
              })
            );
            console.log(`✅ Destinatários atualizados para ${Object.keys(destinatariosMap).length} cargas`);
          } else {
            console.warn('⚠️ Nenhum destinatário encontrado nas viagens');
          }
        } catch (error) {
          console.error('❌ Erro ao buscar destinatários:', error);
        }
      };

      // Buscar destinatários em background (não bloqueia)
      buscarDestinatarios();
    } else {
      setFilteredData([]);
      setPageLoading(false);
    }
  }, [convocations, search]);

  return pageLoading ? (
    <LoadingPage />
  ) : (
    <Container>
      <Card>
        {selectedConvocation && cte ? (
          <ChargeInfos
            convocation={selectedConvocation}
            cte={cte}
            onClose={() => {
              setSelectedConvocation(null);
            }}
          />
        ) : (
          <StaticDrawer
            title="CARGAS"
            icon={Images.IconGrayTruck}
            width="350px"
            mapActived={selectedConvocation != null}
          >
            <Actions>
              <Button
                type="primary"
                icon={Images.Add}
                label="Novo"
                onClick={() => {
                  history.push({
                    pathname: '/createConvocation',
                    state: {
                      selectedId: null,
                      edit: false,
                      convocationId: null,
                    },
                  });
                }}
              />
              <CircleButton
                type="secondary"
                icon={Images.Filter}
                label="Filtrar"
                margin="0 80px 0 0"
                onClick={filterOpen ? handleCloseFilter : handleOpenFilter}
              />
              <AnimatedSearchInput
                onChange={(e) => setSearch(e.target.value)}
                onClear={() => setSearch('')}
                value={search}
              />
            </Actions>
            <CustomScrollbar style={{ height: '73%' }}>
              {filteredData ? (
                filteredData.map((data) => (
                  <ChargeItem
                    key={data.id}
                    selected={selectedConvocation === data}
                    tooglePercurseLogs={tooglePercurseLogs}
                    viewConvocation={viewConvocation}
                    data={data}
                    onEmitirMdfe={handleEmitirMdfe}
                    onConsultarMdfe={handleConsultarMdfe}
                    onCancelarMdfe={handleCancelarMdfe}
                    onEncerrarMdfe={handleEncerrarMdfe}
                    onBaixarPdfMdfe={handleBaixarPdfMdfe}
                    onBaixarXmlMdfe={handleBaixarXmlMdfe}
                    onSincronizarMdfe={handleSincronizarMdfe}
                  />
                ))
              ) : (
                <CircularProgress />
              )}
            </CustomScrollbar>
          </StaticDrawer>
        )}
      </Card>
      {!selectedConvocation && (
        <BoxMap>
          <MapConvocation trips={allActiveTrips} trackingData={allTrackingData} />
        </BoxMap>
      )}
      {modalDelete && (
        <>
          <DeleteModal />
          <BoxMap>
            <MapConvocation />
          </BoxMap>
        </>
      )}
      {messageModal && (
        <>
          <MessageTruckerModal />
          <BoxMap>
            <MapConvocation />
          </BoxMap>
        </>
      )}
      {percurseLogs && (
        <>
          <PercurseLogs
            invoices={invoices}
            onClose={() => setPercurseLogs(null)}
          />
          <BoxMap>
            <MapConvocation />
          </BoxMap>
        </>
      )}
      {error && (
        <BoxMap>
          <ErrorModal
            reload={() => {
              getPaths();
              getCtes();
              getUser();
            }}
            message={error.message}
            onClose={() => {
              setError(null);
            }}
          />
          <MapConvocation />
        </BoxMap>
      )}
      {selectedConvocation && (
        <BoxMap>
          <MapWithAMarker
            truckerLocation={truckerLocation}
            handleOpenPopover={handleOpenTruckerPopover}
            handleOpenMarker={handleOpenMarkerPopover}
            closeModalError={() => setPaths(null)}
            cte={cte}
            loading={loading}
            convocation={selectedConvocation}
            getPaths={getPaths}
            paths={paths}
            invoices={invoices}
            trips={relatedTrips}
            trackingData={filteredTrackingData}
          />
          <CloseButton onClick={() => setSelectedConvocation(null)}>
            <Close className="icon" />
          </CloseButton>
          <Tooltip title="Opções">
            <ButtonDrawer onClick={toogleDrawer}>
              <ChevronLeft className="icon-1" />
              <MoreVert className="icon-2" />
            </ButtonDrawer>
          </Tooltip>
        </BoxMap>
      )}

      <Drawer anchor="right" open={openDrawer} onClose={toogleDrawer}>
        <Header>
          <WrapperLeft>
            <Column>
              <Title color="#122D58">Ações</Title>
            </Column>
          </WrapperLeft>
          <Close className="icon" onClick={toogleDrawer} />
        </Header>
        <BoxDrawerRight>
        </BoxDrawerRight>
      </Drawer>

      {openTruckerPopover && (
        <TruckerPopover
          popoverPosition={popoverPosition}
          open={openTruckerPopover}
          handleOpenPopover={handleOpenTruckerPopover}
          selectedConvocation={selectedConvocation}
          handleClose={handleCloseTruckerPopover}
          cte={cte}
        />
      )}

      {openMarkerPopover && (
        <MarkerPopover
          popoverPosition={markerPopoverPosition}
          open={openMarkerPopover}
          handleOpenMarker={handleOpenMarkerPopover}
          selectedConvocation={selectedConvocation}
          handleClose={handleCloseMarkerPopover}
          selectedInvoice={selectedInvoice}
          cte={cte}
        />
      )}

      {openModalEdit && convocationActive && (
        <Modal
          data={convocations}
          open={openModalEdit}
          onClose={() => dispatch(ConvocationsActions.closeModalEdit())}
          selectedId={convocationActive.id}
          edit={false}
          providers={providers}
        />
      )}

      {openModalQrCode && convocationActive && (
        <QRCode
          convocationKey={convocationActive.id}
          open={openModalQrCode}
          name={convocationActive?.owner}
          phone={convocationActive?.owner_phone}
        />
      )}

      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={() => {
          setOpen(false);
        }}
        placement="top"
        anchorOrigin={{
          vertical: 'center',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'center',
          horizontal: 'left',
        }}
      >
        <WrapperPopover>
          <PopoverText>Tem certeza?</PopoverText>
          <PopoverButton
            onClick={() => {
              handleDelete();
              setOpen(false);
            }}
          >
            Sim
          </PopoverButton>
        </WrapperPopover>
      </Popover>

      <ModalFilter
        data={data}
        form={formFilter}
        resetFilter={handleResetFilter}
        setForm={setFormFilter}
        handleFilter={handleFilter}
        options={filterOptions}
        setOptions={setFilterOptions}
        open={filterOpen}
        handleClose={handleCloseFilter}
      />

      <ModalShare />

      <ModalEventosMdfe
        open={openModalEventosMdfe}
        onClose={() => {
          setOpenModalEventosMdfe(false);
          setSelectedCargaIdMdfe(null);
        }}
        cargaId={selectedCargaIdMdfe}
      />

      <ModalJustificativaCancelamentoMdfe
        open={openModalJustificativaCancelamentoMdfe}
        onClose={() => {
          setOpenModalJustificativaCancelamentoMdfe(false);
          setCargaParaCancelar(null);
        }}
        onConfirm={handleConfirmarCancelamentoMdfe}
        quantidadeMdfe={cargaParaCancelar ? 1 : 0}
      />

      <ModalEncerramentoMdfe
        open={openModalEncerramentoMdfe}
        onClose={() => {
          setOpenModalEncerramentoMdfe(false);
          setCargaParaEncerrar(null);
        }}
        onConfirm={handleConfirmarEncerramentoMdfe}
        quantidadeMdfe={cargaParaEncerrar ? 1 : 0}
      />

      <UserDrawer />
    </Container>
  );
}

export default Convocations;
